import { CheckCircle2, Circle } from "lucide-react";
import { passwordRequirementResults } from "../../lib/passwordPolicy";


export default function PasswordRequirementList({ password }) {
  return (
    <div className="grid gap-1.5 border border-zinc-200 bg-zinc-50 p-3">
      {passwordRequirementResults(password).map((requirement) => (
        <div
          key={requirement.key}
          className={`flex items-center gap-2 text-xs ${requirement.valid ? "text-[#008A00]" : "text-zinc-500"}`}
        >
          {requirement.valid
            ? <CheckCircle2 className="h-3.5 w-3.5 shrink-0" />
            : <Circle className="h-3.5 w-3.5 shrink-0" />}
          {requirement.label}
        </div>
      ))}
    </div>
  );
}

